export interface GlobalAppConfig {
  marApiBaseUrl: string;
  marApiSearchPath: string;
  marApiAutoCompletePath: string;
  marApiApiKey: string;
  marApiRejectionCharacters: string;
}

export const globalAppConfig: GlobalAppConfig = {
  marApiBaseUrl:
    process.env.REACT_APP_MAR_BASE_URL ?? "https://datagate.dc.gov/mar/open",
  marApiSearchPath:
    process.env.REACT_APP_MAR_SEARCH_PATH ?? "/api/v2.2/locations",
  marApiAutoCompletePath:
    process.env.REACT_APP_MAR_AUTOCOMPLETE_PATH ?? "/api/v2.2/autocomplete",
  marApiApiKey: process.env.REACT_APP_MAR_API_KEY ?? "",
  marApiRejectionCharacters:
    process.env.REACT_APP_MAR_REJECTION_CHARACTERS ?? "/",
};
